import { authService } from '../auth/auth.service';
import ServiceVersions from './serviceVersions.component';
import config from '@/config/config';
import { openDialog } from '@/util/imperativeDialog';
import { request } from '@whiz-cart/ui-shared/request/request';
import { createCache } from 'cross-state';

export default ((window as any).serviceVersionsService = new (class {
    show() {
        openDialog(ServiceVersions);
    }

    getVersion = createCache(
        async (backend: string) => {
            const { backends, endpoints } = config;
            const baseUrl = backends[backend as keyof typeof backends];
            const endpoint = endpoints[backend as keyof typeof endpoints];
            const path = 'version' in endpoint ? endpoint.version : 'version';

            const result = await request({
                method: 'GET',
                url: `${baseUrl}/${path}`,
                accessToken: () => authService.accessToken.get(),
            });
            return result as { app: string; version: string };
        },
        { invalidateAfter: 60_000, invalidateOnWindowFocus: false },
    );
})());
